import React, { useState, useEffect, Fragment } from "react";
import useAxiosPrivate from "../../hooks/useAxiosPrivate";
import { useNavigate, useLocation } from "react-router-dom";
import Card from "react-bootstrap/Card";
import { Button, Spinner } from "react-bootstrap";
import DropDownSelect from "./DropDownSelect";
import BhinaMeetingCalendarModal from "../bhinameeting/BhinaMeetingCalendarModal";
import Add from "./Add";

const baseURL = process.env.REACT_APP_API_JOBS;

const formatTime = (timeString) => {
  const [hours, minutes] = timeString.split(":");
  return `${hours}:${minutes}`; // Returns time in HH:mm format
};

const Mekhrazeem = () => {
  const [mekhrazeem, setMekhrazeem] = useState(null);
  const [mkhTypeOptions, setMkhTypeOptions] = useState([]);
  const [addVisible, setAddVisible] = useState(false);
  const [added, setAdded] = useState(0);
  const [year, setYear] = useState(new Date().getFullYear());
  const [searchString, setSearchString] = useState("");
  const [loading, setLoading] = useState(true);
  const [showMeetingsCalender, setShowMeetingsCalender] = useState(false);
  const axiosPrivate = useAxiosPrivate("application/json");
  const navigate = useNavigate();
  const location = useLocation();
  const [years, setYears] = useState([]);
  let displayMekhrazeem = null;
  const toDay = new Date(Date.now());

  const bhinaMeetingsCalender = (e) => {
    setShowMeetingsCalender(true);
  };

  useEffect(() => {
    document.body.classList.add("accountBodyColor");

    // Clean up function to remove the class when the component unmounts
    return () => {
      document.body.classList.remove("accountBodyColor");
    };
  }, []);
  useEffect(() => {
    document.body.classList.add("accountBodyColor");
    let isMounted = true;
    const controller = new AbortController();
    const getYears = async () => {
      try {
        const response = await axiosPrivate
          .get(baseURL + "years/", {
            signal: controller.signal,
          })
          .then((response) => {
            const distinctSortedYears = [
              ...new Set([...response.data.years, new Date().getFullYear()]),
            ].sort((a, b) => b - a);
            setYears(distinctSortedYears);
          });
      } catch (err) {
        console.error(err);
      }
    };
    getYears();
    return () => {
      //document.body.classList.remove("accountBodyColor");
      isMounted = false;
      isMounted && controller.abort();
    };
  }, []);

  useEffect(() => {
    let isMounted = true;
    //setLoading(true);
    const controller = new AbortController();
    const getData = async () => {
      try {
        const response = await axiosPrivate.get(
          baseURL + "mekhrazlist/?year=" + year,
          {
            signal: controller.signal,
          },
        );
        isMounted && setMekhrazeem(response.data);
      } catch (err) {
        console.error(err);
        navigate("/login", { state: { from: location }, replace: true });
      }
    };
    getData();
    const getMkhTypeOptions = async () => {
      try {
        const response = await axiosPrivate.get(baseURL + "mkhtype/", {
          signal: controller.signal,
        });
        isMounted && setMkhTypeOptions(response.data[0].mkhtypeOptions);
        setLoading(false);
      } catch (err) {
        console.error(err);
        navigate("/login", { state: { from: location }, replace: true });
      }
    };

    getMkhTypeOptions();

    return () => {
      isMounted = false;
      isMounted && controller.abort();
    };
  }, [added, year]);

  if (loading) {
    return (
      <div
        className="d-flex justify-content-center align-items-center"
        style={{ height: "100vh" }}
      >
        <div className="text-center">
          <Spinner animation="border" variant="danger" visible />

          <br />
          <br />
          <h3 className="spinnerText">המתן עד סיום הפעולה.</h3>
        </div>
      </div>
    );
  } else {
    if (!mekhrazeem) return null;

    const handleSearch = (e) => {
      displayMekhrazeem = mekhrazeem.filter((mkh) =>
        mkh.title.includes(e.target.value),
      );
      setSearchString(e.target.value);
    };

    const gotoMekhrazAdmin = (e) => {
      navigate("/mekhrazadmin/:" + e.target.value);
    };

    return (
      <>
        {showMeetingsCalender && (
          <BhinaMeetingCalendarModal
            showMeetingsCalender={showMeetingsCalender}
            setShowMeetingsCalender={setShowMeetingsCalender}
          />
        )}

        <Add
          mkhTypeOptions={mkhTypeOptions}
          addVisible={addVisible}
          setAddVisible={setAddVisible}
          setAdded={setAdded}
        />
        <Fragment>
          <ul style={{ visibility: addVisible ? "hidden" : "initial" }}>
            <Card
              bg="light"
              style={{ maxWidth: "45rem" }}
              className="mb-1  mx-auto"
            >
              <Card.Header
                style={{
                  textAlign: "center",
                  fontWeight: "bold",
                  backgroundColor: "gray",
                }}
              >
                <h1>טיפול במכרזים</h1>
              </Card.Header>
              <Card.Body>
                <form onSubmit={(e) => e.preventDefault()}>
                  <input
                    type="text"
                    id="search"
                    placeholder="הקלד טקסט לחיפוש"
                    onChange={handleSearch}
                  />
                </form>
                <center>
                  <DropDownSelect items={years} setYear={setYear} year={year} />
                </center>
                <Card.Footer className="d-flex justify-content-between">
                  <Button
                    type="submit"
                    variant="primary"
                    onClick={() => setAddVisible(true)}
                  >
                    מכרז חדש
                  </Button>
                  <Button onClick={bhinaMeetingsCalender} variant="primary">
                    הצג מועדי ישיבות הבחינה
                  </Button>
                </Card.Footer>
              </Card.Body>
            </Card>

            {mekhrazeem?.length === 0 ? (
              <p
                style={{
                  textAlign: "center",
                  marginTop: "20px",
                  color: "white",
                  fontSize: "16px",
                }}
              >
                לא קיימים מכרזים להצגה!
              </p>
            ) : (
              mekhrazeem
                ?.filter(
                  (mkh) =>
                    mkh.persom_date.includes(year) &&
                    mkh.title.includes(searchString),
                )
                ?.map((mekhraz) => {
                  const ahron = new Date(
                    new Date(
                      Date.parse(mekhraz.hagsha_date) + 24 * 60 * 60 * 1000,
                    ).setHours(0, 1, 0, 0),
                  );
                  const dateOver = toDay > ahron;

                  const [checkedStr, totalStr] =
                    mekhraz.all_nevdak_true.split("/");
                  const checked = parseInt(checkedStr, 10);
                  const total = parseInt(totalStr, 10);
                  const allChecked = total > 0 && checked >= total;
                  const progress =
                    total > 0 ? Math.round((checked / total) * 100) : 0;

                  const hasMeeting = mekhraz.bhina_meeting?.length > 0;
                  const meetingDate = hasMeeting
                    ? mekhraz.bhina_meeting[0].mt_date
                    : null;
                  const meetingTime = hasMeeting
                    ? formatTime(mekhraz.bhina_meeting[0].start_time)
                    : null;
                  const meetingPast =
                    hasMeeting && toDay > new Date(meetingDate);

                  const headerBg = dateOver ? "#888780" : "#1D9E75";
                  return (
                    <Card
                      key={mekhraz.id}
                      bg={dateOver ? "secondary" : "success"}
                      text="white"
                      style={{ maxWidth: "45rem" }}
                      className="mb-2  mx-auto"
                    >
                      <Card.Header>
                        <h5
                          style={{
                            display: "flex",
                            justifyContent: "space-between",
                            alignItems: "center",
                          }}
                        >
                          <span
                            style={{
                              background: "rgba(255,255,255,0.2)",
                              color: "#ffd700",

                              fontWeight: 500,
                              padding: "3px 10px",
                              borderRadius: 20,
                              textDecoration: mekhraz.canceled
                                ? "line-through"
                                : "none",
                            }}
                          >
                            {mekhraz.mkh_num} {mekhraz.mkh_type}
                          </span>
                          <span style={{ marginLeft: "1rem" }}>
                            {"מועד אחרון להגשה: "}
                            {mekhraz.hagsha_date}
                          </span>

                          <div
                            style={{
                              display: "flex",
                              gap: 6,
                              flexWrap: "wrap",
                              alignItems: "center",
                            }}
                          >
                            {!hasMeeting ? (
                              <span
                                style={{
                                  background: "#FAEEDA",
                                  color: "#633806",
                                  fontSize: 15,
                                  fontWeight: 500,
                                  padding: "3px 12px",
                                  borderRadius: 20,
                                }}
                              >
                                ⚠ טרם נקבעה ישיבה
                              </span>
                            ) : meetingPast ? (
                              <span
                                style={{
                                  background: "#FCEBEB",
                                  color: "#A32D2D",
                                  fontSize: 15,
                                  fontWeight: 500,
                                  padding: "3px 12px",
                                  borderRadius: 20,
                                }}
                              >
                                מועד הישיבה {meetingDate}
                              </span>
                            ) : (
                              <span
                                style={{
                                  background: "#E1F5EE",
                                  color: "#085041",
                                  fontSize: 15,
                                  fontWeight: 500,
                                  padding: "3px 12px",
                                  borderRadius: 20,
                                }}
                              >
                                ישיבה: {meetingDate} {meetingTime}
                              </span>
                            )}
                          </div>
                        </h5>
                      </Card.Header>

                      <Card.Body style={{ textAlign: "center" }}>
                        <Card.Title
                          style={{
                            margin: 0,
                            fontSize: 17,
                            fontWeight: 500,
                            textDecoration: mekhraz.canceled
                              ? "line-through"
                              : "none",
                          }}
                        >
                          {mekhraz.title}
                        </Card.Title>
                      </Card.Body>

                      <Card.Footer
                        style={{
                          display: "flex",
                          justifyContent: "space-between",
                          alignItems: "center",
                        }}
                      >
                        {allChecked && (
                          <span
                            style={{
                              background: "#EAF3DE",
                              color: "#27500A",
                              fontSize: 13,
                              fontWeight: 500,
                              padding: "3px 12px",
                              borderRadius: 20,
                            }}
                          >
                            ✓ בדיקה הושלמה
                          </span>
                        )}
                        <p
                          style={{
                            margin: 0,
                            fontSize: 16,
                            //fontWeight: "bold",
                            color:
                              mekhraz.all_nevdak_true.split("/")[0] ===
                                mekhraz.all_nevdak_true.split("/")[1]
                                ? "white"
                                : "#ffd700",
                          }}
                        >
                          מספר המועמדים שנבדקו {mekhraz.all_nevdak_true} --
                          העומדים בתנאי הסף: {mekhraz.all_saf_true}
                        </p>

                        <Button
                          variant="danger"
                          value={mekhraz.id}
                          onClick={() =>
                            navigate("/mekhrazadmin/" + mekhraz.id)
                          }
                        >
                          ניהול המכרז
                        </Button>
                      </Card.Footer>
                    </Card>
                  );
                })
            )}
          </ul>
        </Fragment>
      </>
    );
  }
};
export default Mekhrazeem;
